<template>
  <section class="">
    <carousel :perPage="6"  :autoplayHoverPause='false' :autoplay="true" :loop="true" >
      <slide v-for="(item,index) in imageoption" :key="index" :isTouch="true" :caption="item.id" :title="item.id">
       <img :src="item.image" class="banner" :value="item.id">
       
      </slide>
    </carousel>
  </section>
</template>

<script>
  export default {
    
    data() {
      return {
        imageoption: [
          {"id":"1","image":"/img/hotels/Le-Meridien-Goa-hotel/1.jpg"},
          {"id":"2","image":"/img/hotels/Le-Meridien-Goa-hotel/2.jpg"},
          {"id":"3","image":"/img/hotels/Le-Meridien-Goa-hotel/3.jpg"},
          {"id":"4","image":"/img/hotels/Le-Meridien-Goa-hotel/1.jpg"},
          {"id":"5","image":"/img/hotels/Le-Meridien-Goa-hotel/2.jpg"},
          {"id":"6","image":"/img/hotels/Le-Meridien-Goa-hotel/3.jpg"},
          {"id":"7","image":"/img/hotels/Le-Meridien-Goa-hotel/1.jpg"},
          {"id":"8","image":"/img/hotels/Le-Meridien-Goa-hotel/2.jpg"},
          {"id":"9","image":"/img/hotels/Le-Meridien-Goa-hotel/3.jpg"},
        ],
      };
    },
  };
</script>
<style  scoped>


.banner{
  height: 100%;
  width: 100%;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}

</style>